import { getFormValues } from 'redux-form';
import { getProject } from '../../../HttpRequests/projects';
import { loadProject } from '../State/project';
import { FORM_NAME } from '../Form';
import alertIfClientIsHighRisk from './alertIfClientIsHighRisk';
import handleException from '../../../Core/Helpers/handleException';
import { getProps } from '../props';

export default () => async (dispatch, getState) => {

  const values = getFormValues(FORM_NAME)(getState());
  const { order, projectId } = getProps();

  // Get project_id from order prop (when editing), projectId prop (when creating from estimate), or form values (when manually selecting)
  const id = (order && order.project_id) || projectId || (values && values.project_id);

  if (!id) return;

  try {

    const params = {};

    params.include = [
      'clientSite',
      'clientSite.client',
      'clientSite.client.clientContacts',
      'estimates',
      'orders'
    ].join();

    params['filter[status_key]'] = [1,2];

    const response = await getProject({ id, params });

    dispatch(loadProject(response.data.data));

    dispatch(alertIfClientIsHighRisk(response.data.data));

  } catch (error) {

    handleException(error);

  }
}
